export function formatDuration(seconds) {
  const totalSeconds = Math.floor(Number(seconds));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(secs).padStart(2, '0');

  if (hours > 0) {
      const formattedHours = String(hours).padStart(2, '0');
      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  } else {
      return `${formattedMinutes}:${formattedSeconds}`;
  }
}

export function formatDurationMobile(seconds) {
  const totalSeconds = Math.floor(Number(seconds));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);

  const formattedMinutes = String(minutes);

  if (hours > 0) {
      const formattedHours = String(hours);
      return `${formattedHours}h ${formattedMinutes}m`;
  } else {
      return `${formattedMinutes}m`;
  }
}